/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import  '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import './components/aos';


import './components/block-cart';
import lazysizes from 'lazysizes';

/*menu sticky*/
import Headroom from "headroom.js";


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  topMenu.init();

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
  })
  
  //menu fixe avec la librairie headroom.js
	if($("body:not(#checkout) .l-header").length >0){
	  const header = document.querySelector("body:not(#checkout) .l-header");
	  var options_headroom = {offset : 50};
	  const headroom = new Headroom(header,options_headroom);
		headroom.init();
	}
	
		/****click sur tout cadre rerige vers url****/
	if($(".click-all .cb-item-content>a").length>0){
				$(".click-all .cb-item").click(function(e){
					if ($(this).find(".cb-item-content>a").length) {
						if($(this).find(".cb-item-content>a").attr('target')=='_blank'){
							window.open($(this).find(".cb-item-content>a").attr("href"));
						} 
						else document.location.href = $(this).find(".cb-item-content>a").attr("href");
						e.preventDefault();
					}
				});
	}	
	
		/****couper/ouvrir paragraphe presentation home****/	
	
		var text_cut = $("#custom-text .text_cut");
		if (text_cut.length > 0 ){
			var text_cut_height = text_cut.height();
				text_cut.addClass("close_text_cut");	
			$("#custom-text .toggle .btn").click(function(e) {
				var status = text_cut.hasClass("open");
				if(!status){
					text_cut.removeClass("close_text_cut");
					text_cut.addClass("open");		
					text_cut.css("max-height",text_cut_height);		
				}
				else{
					text_cut.css("max-height","inherit");			
					text_cut.removeClass("open");		
					text_cut.addClass("close_text_cut");
					
					$('html, body').animate({
						scrollTop: $("#custom-text").offset().top-100}, 1200);
					}
			});
		}

	/*gestion de l'ancre sur le bloc hero*/
	if ($("#index .box-video").length > 0) {
		$("#index .box-video").each(function (index) {
			$(this).append('<a href="#" class="scrollLink"><i class="material-icons" aria-hidden="true">keyboard_arrow_down</i><i class="material-icons" aria-hidden="true">keyboard_arrow_down</i></a>');
		});
	}

	document.querySelectorAll('.scrollLink').forEach(link => {
		link.addEventListener('click', function(e) {
			e.preventDefault();
			document.querySelector('.anchorContent')?.scrollIntoView({ behavior: 'smooth' });
		});
	});

	const sliderTreeBlocsElement = $('.slider-tree_blocs');
	
	// Hide slider during initialization
	sliderTreeBlocsElement.css({'opacity': '0', 'transition': 'opacity 0.3s ease'});
	
	setTimeout(() => {
		sliderTreeBlocsElement.slick({
			dots: false,
			infinite: true,
			centerPadding: '15px',
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 2000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
		// Show slider after initialization
		sliderTreeBlocsElement.css('opacity', '1');
	}, 100);

	const sliderProjetElement = $('#slider-projet > .elementor-column-wrap > .elementor-widget-wrap');
	
	// Hide slider during initialization
	sliderProjetElement.css({'opacity': '0', 'transition': 'opacity 0.3s ease'});
	
	// Initialize Slick with a small delay to ensure DOM is ready
	setTimeout(() => {
		sliderProjetElement.slick({
			dots: false,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 2000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: false,
						centerPadding: '0px',
						arrows: false,
						infinite: true
					}
				}
			]
		});
		// Show slider after initialization
		sliderProjetElement.css('opacity', '1');
	}, 100);

	const sliderProjetElementRectangle = $('#slider-projet-rectangle > .elementor-column-wrap > .elementor-widget-wrap');

	sliderProjetElementRectangle.css({'opacity': '0', 'transition': 'opacity 0.3s ease'});

	setTimeout(() => {
		sliderProjetElementRectangle.slick({
			dots: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: false,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 2000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: false,
						centerPadding: '0px',
						arrows: false,
						infinite: true
					}
				}
			]
		});
		// Show slider after initialization
		sliderProjetElementRectangle.css('opacity', '1');
	}, 100);

	const navBreadcrumb = document.querySelector('.breadcrumb');
	if (!navBreadcrumb) return;

	let isDown = false;
	let startX;
	let scrollLeft;
	let dragged = false;

	navBreadcrumb.addEventListener('mousedown', (e) => {
		console.log('mousedown');
		isDown = true;
		dragged = true;
		navBreadcrumb.classList.add('dragging');
		startX = e.pageX - navBreadcrumb.offsetLeft;
		scrollLeft = navBreadcrumb.scrollLeft;
	});

	navBreadcrumb.addEventListener('mouseleave', () => {
		console.log('mouseleave');
		dragged = true;
		isDown = false;
		navBreadcrumb.classList.remove('dragging');
	});

	navBreadcrumb.addEventListener('mouseup', () => {
		isDown = false;
		navBreadcrumb.classList.remove('dragging');
	});

	navBreadcrumb.addEventListener('mousemove', (e) => {
		if (!isDown) return;

		dragged = false;
		e.preventDefault();

		const x = e.pageX - navBreadcrumb.offsetLeft;
		const walk = (x - startX) * 1.5;
		navBreadcrumb.scrollLeft = scrollLeft - walk;
	});

	console.log(navBreadcrumb);

	navBreadcrumb.querySelectorAll('.breadcrumb-item').forEach(link => {
		link.addEventListener('click', (e) => {
			console.log('click');
			console.log(dragged);
			if (!dragged) {
				console.log('no');
				e.preventDefault();
				e.stopPropagation();
			}else {
				console.log('yes');
			}
		});
	});

});

// Refresh Slick positioning when lazy images are loaded
document.addEventListener('lazyloaded', function(e){
	$(e.target).parent().addClass('rc--lazyload');
	
	// Recalculate Slick dimensions after images load
	const $slider = $('#slider-projet > .elementor-column-wrap > .elementor-widget-wrap');
	if ($slider.hasClass('slick-initialized')) {
		$slider.slick('setPosition');
	}
	const $sliderTree = $('.slider-tree_blocs');
	if ($sliderTree.hasClass('slick-initialized')) {
		$sliderTree.slick('setPosition');
	}
});
